import React from "react";

import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { BaseBean, NodeData } from "../ds/client_ds.js";
import {
  FabricStyleSearchCriteria,
  FabricStyleSKUBean,
  PageListBean,
  PhysicalInventoryAdjustmentBean,
  PhysicalInventoryAdjustmentBinLocationBean,
  PhysicalInventoryAdjustmentMissingInventoryBean,
  PhysicalInventoryAdjustmentPhysicalInventoryBean,
  PhysicalInventoryAdjustmentSearchCriteria,
  RestEntityUnLockRequest,
  RestFabricStyleListBeanRequest,
  RestPageListBean,
  RestPhysicalInventoryAdjustmentListRequest,
  RestReadRequest,
  SKUBatchInventoryBinLocationSearchCriteria,
} from "../ds/ds.js";
import { DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  DataGridColumnDefinition,
  DatePickerComponent,
  EditableDataGrid,
  InputCheckbox,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { PhysicalInventoryAdjustmentLookupHandler } from "../lookup/PhysicalInventoryAdjustmentLookupHandler.js";
import { PopupInventoryAdjustmentModule } from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { InventoryService } from "../services/InventoryService.js";
import { BaseNodeBar, BaseToolBar, ModuleToolBar } from "./BaseModule.js";
import { ModuleUtils } from "./ModuleUtils.js";
import { ShieldAlert, ShieldCheck,Download,AlertCircle }from "lucide-react";

class PhysicalInventoryAdjustment extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Physical Inventory Adjustment",
      isShowModuleSearchContainer: true,
      moduleKeyCode: "NEW",
      moduleCaption: "Physical Inventory Adjustment",
      isResetModule: false,
      physicalInventoryAdjustmentLookupHandler: null,
      isShowExecuteButton: false,
      isShowSelectButton: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowResetButton: false,
      isShowExitButton: true,
      isShowNewTextBoxButton: false,
      dataList: new Array(),
      error_list: [],
      inquiryDataList: [],
      criteria: new PhysicalInventoryAdjustmentBean(),
      listCriteria: new PhysicalInventoryAdjustmentSearchCriteria(),
      pageList: new RestPageListBean(),
      isPhysicalInventoryListFormOpen: false,
      isPhysicalInventoryEntryFormOpen: true,
      isShowAlert: false,
      alertMsg: "",
      alertMessage: [],
      alertType: "",
      success_list: [],
      missInv: [],
      phyInv: [],
      isShowInventoryAdjustmentModule: false,
      moduleForPopup: [],
      nodeList: [],
      selectedNodeKey: "nonVerifiedLines",
      inquiryData: null,
      isShowNonVerified: true,
      isShowVerified: false,
      colorLookupHandler: null,
      isShowColorLookup: false,
      colorList: new Array(),
      isShowRollSkuPopup: false,
      isShowLookup: true,
      isDisabledFields: false,
      fabricLookupHandler: null,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricList: true,
      showAutoCompleteFabricColorList: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      physicalInventoryAdjustmentData: [],
      checkTextBox: true,
      selectedRollSkuList: [],
      order: "asc",
      sortField: "",
      is3PL: false,
      isViewMode: false,
      isReseted: false,
      disabled: false,
    };
  }
  isLocked = false;
  code = "NEW";
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.initLookupHandlers();
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    let currentPage = this.state.pageList.currentPage;
    if (currentPage == null || currentPage <= 0) {
      pageInput.currentPage = 1;
    } else {
      pageInput.currentPage = currentPage;
    }
    this.state.pageList = pageInput;
    if (this.props.code !== "" && this.props.code !== undefined) {
      this.code = this.props.code;
      //this.unlockPhysicalInventoryAdjustment(this.props.code, false);
      this.editPhysicalInventoryAdjustment(this.props.code);
      this.setState({
        isViewMode: false,
      });
    } else {
      this.addNewPhysicalInventoryAdjustment();
      // this.loadPhysicalInventoryAdjustmentPage();
    }
    ModuleUtils.getPurchaseOrderStatusList();
    this.getNodeList();
  }
  initLookupHandlers = () => {
    let physicalInventoryAdjustmentLookupHandler =
      new PhysicalInventoryAdjustmentLookupHandler(
        this.companyCode,
        "Physical Inventory Adjustment"
      );
    this.setState({
      physicalInventoryAdjustmentLookupHandler:
        physicalInventoryAdjustmentLookupHandler,
    });
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  // unlockPhysicalInventoryAdjustment = (code, isNew) => {
  //   let request = new RestEntityUnLockRequest();
  //   request.companyCode = this.companyCode;
  //   request.entityCode = code;
  //   request.isNew = isNew;
  //   if (
  //     SecurityAccessManager.PhysicalInventoryAdjustmentMaintainance_IsAccessible()
  //   ) {
  //     InventoryService.unLockPhysicalInventoryAdjustmentNumber(
  //       request,
  //       this.unlockPhysicalInventoryAdjustmentResponse,
  //       this.errorCallBack
  //     );
  //   } else {
  //     this.inValid(1);
  //   }
  // };
  disable = () => {
    this.setState({
      isDisabledFields: true,
    });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  handleResponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription)
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  moduleExit = () => {
    let criteria = this.state.criteria;
    if (criteria.code === "NEW") {
      this.props.onModuleExit();
    } else {
      if (!this.state.isViewMode && this.isLocked)
        this.unlockPhysicalInventoryAdjustment(criteria.code);
      this.props.onModuleExit();
    }
  };
  listFormOnChange = (e) => {
    let criteria = this.state.listCriteria;
    criteria["physicalInventoryAdjustmentNumber"] = e.target.value;
    this.setState({ listCriteria: criteria });
  };
  resetFilter = () => {
    let criteria = new PhysicalInventoryAdjustmentSearchCriteria();
    criteria.companyCode = this.companyCode;
    this.state.listCriteria = criteria;
    this.setState({ listCriteria: criteria });
    this.loadPage(1);
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  filter = () => {
    this.loadPage(1);
  };
  resetFilteredCR = () => {
    let criteria = new PhysicalInventoryAdjustmentSearchCriteria();
    criteria.companyCode = this.companyCode;
    this.state.listCriteria = criteria;
    this.setState({ listCriteria: criteria });
    this.loadPage(1);
  };
  getModuleListView = () => {
    let criteria = this.state.criteria;
    if (criteria.code === "NEW") {
      this.closePhysicalInventoryEntryForm();
      this.loadPhysicalInventoryAdjustmentPage();
    } else {
      if (!this.state.isViewMode && this.isLocked)
        this.unlockPhysicalInventoryAdjustment(criteria.code, false);
      this.closePhysicalInventoryEntryForm();
      this.loadPhysicalInventoryAdjustmentPage();
    }
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.listCriteria;
    criteria.companyCode = this.companyCode;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    this.state.pageList = pageInput;
    this.loadPhysicalInventoryAdjustmentPage();
  };
  loadPhysicalInventoryAdjustmentPage = () => {
    let criteria = this.state.listCriteria;
    criteria.companyCode = this.companyCode;
    let pageList = new PageListBean();
    pageList = this.state.pageList;
    let cust_requestInput = new RestPhysicalInventoryAdjustmentListRequest();
    cust_requestInput.pageInput = pageList;
    cust_requestInput.searchCriteria = criteria;
    if (SecurityAccessManager.PhysicalInventoryAdjustmentView_IsAccessible()) {
      InventoryService.getPhysicalInventoryAdjustmentPageList(
        cust_requestInput,
        this.loadPhysicalInventoryAdjustmentResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadPhysicalInventoryAdjustmentResponse = (response) => {
    let PhysicalInventoryAdjustment = new Array();
    let pageList = this.state.pageList;
    if (response.data.physicalInventoryAdjustmentPageList != null) {
      PhysicalInventoryAdjustment =
        response.data.physicalInventoryAdjustmentPageList
          .physicalInventoryAdjustments;
      pageList.totalCount =
        response.data.physicalInventoryAdjustmentPageList.totalCount;
      pageList.currentPage =
        response.data.physicalInventoryAdjustmentPageList.currentPage;
    } else {
      PhysicalInventoryAdjustment = new Array();
    }
    this.setState({
      criteria: PhysicalInventoryAdjustment,
      physicalInventoryAdjustmentData: PhysicalInventoryAdjustment,
      pageList: pageList,
    });
  };
  editPhysicalInventoryAdjustment = (code) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = code;
    let isLockRequired = "NEW" === code ? false : true;
    readrestInput.isLockRequired = isLockRequired;
    if (SecurityAccessManager.PhysicalInventoryAdjustmentView_IsAccessible()) {
      InventoryService.initPhysicalInventoryAdjustmentModule(
        readrestInput,
        this.editPhysicalInventoryAdjustmentResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  editPhysicalInventoryAdjustmentResponse = (response) => {
    this.setState({ inquiryDataList: [] });
    let errMsg = "";
    let inquiryDataList = [];
    let criteria = this.state.criteria;
    let phyInv = [];
    let missInv = [];
    if (response.data.lockResponse != null) {
      if (!isEmpty(response.data.lockResponse.errors)) {
        this.showErrorMessage(response.data.lockResponse);
        this.state.isViewMode = true;
      }
    }
    if (response.data.physicalInventoryResponse != null) {
      if (response.data.physicalInventoryResponse.errors != null) {
        response.data.physicalInventoryResponse.errors.map((err) => {
          errMsg = err.messageDescription;
        });
      }
    }
    if (
      errMsg !=
      " FabricStyle Inventory Adjustment " +
        this.state.moduleKeyCode +
        " Not Read Sucessfully "
    ) {
      this.showErrorMessage(response.data.physicalInventoryResponse);
    } else {
      if (this.state.moduleKeyCode != "NEW") this.isLocked = true;
    }
    if (response.data != null) {
      if (response.data.physicalInventoryResponse != null) {
        if (
          response.data.physicalInventoryResponse.physicalInventoryAdjustment !=
          null
        ) {
          const physicalinventoryadjustment =
            response.data.physicalInventoryResponse.physicalInventoryAdjustment;
          inquiryDataList =
            response.data.physicalInventoryResponse.physicalInventoryAdjustment;
          if (!isEmpty(inquiryDataList)) {
            let physicalInventoryAdjustmentBean =
              new PhysicalInventoryAdjustmentBean();
            physicalInventoryAdjustmentBean.companyCode =
              inquiryDataList.companyCode;
            physicalInventoryAdjustmentBean.code =
              physicalinventoryadjustment.code;
            physicalInventoryAdjustmentBean.fromDate = inquiryDataList.fromDate;
            physicalInventoryAdjustmentBean.toDate = inquiryDataList.toDate;
            physicalInventoryAdjustmentBean.remarks = inquiryDataList.remarks;
            physicalInventoryAdjustmentBean.notes = inquiryDataList.notes;
            physicalInventoryAdjustmentBean.fabricStyleCode =
              inquiryDataList.fabricStyleCode;
            physicalInventoryAdjustmentBean.fabricStyleColorCode =
              inquiryDataList.fabricStyleColorCode;
            physicalInventoryAdjustmentBean.includeHoldingWarehouse =
              inquiryDataList.includeHoldingWarehouse;
            physicalInventoryAdjustmentBean.binLocations =
              inquiryDataList.binLocations;
            let binlocation = [];
            let binLocations = [];
            binLocations = inquiryDataList.binLocations;
            for (let item of binLocations) {
              criteria.companyCode = item.companyCode;
              criteria.physicalInventoryAdjustmentNumber =
                physicalinventoryadjustment.code;
              criteria.isActive = item.isActive;
              criteria.binLocation = item.binLocation;
              criteria.createdBy = item.createdBy;
              criteria.createdDate = item.createdDate;
              criteria.updatedBy = item.updatedBy;
              criteria.updatedDate = item.updatedDate;
              criteria.physicalInventoryQuantity =
                item.physicalInventoryQuantity;
              criteria.totalInventoryQuantity = item.totalInventoryQuantity;
              criteria.totalInventoryRolls = item.totalInventoryRolls;
              criteria.totalMissingInventoryRolls =
                item.totalMissingInventoryRolls;
              criteria.totalPhysicalInventoryRolls =
                item.totalPhysicalInventoryRolls;
              criteria.uomCode = item.uomCode;
              criteria.lineNumber = item.lineNumber;
              criteria.missingInventoryQuantity = item.missingInventoryQuantity;
              criteria.adjustUnAvailable = item.adjustUnAvailable;
              criteria.missingInventories = item.missingInventories;
              missInv = criteria.missingInventories;
              criteria.physicalInventories = item.physicalInventories;
              phyInv = criteria.physicalInventories;
            }
            binlocation.push(criteria);
          }
          let moduleKeyCode = physicalinventoryadjustment.code;
          let pageTitle = this.moduleCaption + " - VIEW";
          this.setState({
            criteria: physicalinventoryadjustment,
            inquiryDataList: inquiryDataList,
            phyInv: phyInv,
            missInv: missInv,
            pageTitle: pageTitle,
            moduleKeyCode: moduleKeyCode,
            isShowSaveButton: false,
            isShowExecuteButton: false,
            isShowSelectButton: false,
            isShowNewTextBoxButton: true,
          });
          this.state.criteria = physicalinventoryadjustment;
          this.isLocked = true;
          this.openExistingPhysicalInventoryEntryForm();
        } else {
          this.addNewPhysicalInventoryAdjustment();
        }
      }
    }
  };
  unlockPhysicalInventoryAdjustmentResponse = (response) => {
    if (!isEmpty(response.data)) {
      if (response.data.isSuccess) {
      } else {
        if (!this.state.isReseted) this.showErrorMessage(response.data);
      }
    }
  };
  unlockPhysicalInventoryAdjustment = (code, isNew) => {
    let request = new RestEntityUnLockRequest();
    request.companyCode = this.companyCode;
    request.entityCode = code;
    request.isNew = isNew;
    if (
      SecurityAccessManager.PhysicalInventoryAdjustmentMaintainance_IsAccessible()
    ) {
      InventoryService.unLockPhysicalInventoryAdjustmentNumber(
        request,
        this.unlockPhysicalInventoryAdjustmentResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  moduleCaption = "Physical Inventory Adjustment";
  closePhysicalInventoryEntryForm = () => {
    let pageTitle = this.moduleCaption;
    this.setState({
      isPhysicalInventoryListFormOpen: true,
      isPhysicalInventoryEntryFormOpen: false,
      isShowNewButton: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      error_list: [],
      isShowModuleSearchContainer: false,
      moduleKeyCode: "NEW",
      isDisabledFields: false,
      isResetView: false,
      isViewMode: false,
      disabled: false,
    });
  };
  addNewPhysicalInventoryAdjustment = () => {
    let newPhysicalInventory = new PhysicalInventoryAdjustmentBean();
    newPhysicalInventory.companyCode = this.companyCode;
    newPhysicalInventory.fabricStyleName = "";
    newPhysicalInventory.code = "NEW";
    newPhysicalInventory.binLocations = new Array();
    newPhysicalInventory.missingInventories = [];
    let pageTitle = this.state.moduleCaption + " - NEW";
    if (!isEmptyString(this.state.moduleKeyCode)) {
      newPhysicalInventory.code = this.state.moduleKeyCode;
    } else newPhysicalInventory.code = "NEW";
    let inquiryDataList = new Array();
    this.setState({
      criteria: newPhysicalInventory,
      inquiryDataList: inquiryDataList,
      missInv: [],
      phyInv: [],
      pageTitle: pageTitle,
      isShowSaveButton: true,
      isShowExecuteButton: true,
      isShowSelectButton: true,
      isShowNewTextBoxButton: false,
    });
    this.state.isDisabledFields = false;
    this.state.criteria = newPhysicalInventory;
    this.openPhysicalInventoryEntryForm();
  };
  openPhysicalInventoryEntryForm = () => {
    let criteria = this.state.criteria;
    let inquiryDataList = this.state.inquiryDataList;
    this.setState({
      criteria: criteria,
      inquiryDataList: inquiryDataList,
      isPhysicalInventoryEntryFormOpen: true,
      isPhysicalInventoryListFormOpen: false,
      isShowSaveButton: true,
      isShowExecuteButton: true,
      isShowSelectButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: true,
      isShowModuleSearchContainer: true,
      isResetView: true,
      missInv: [],
      phyInv: [],
    });

    if (this.state.moduleKeyCode != "NEW") {
      this.setState({ disabled: true });
    }
  };
  openExistingPhysicalInventoryEntryForm = () => {
    let criteria = this.state.criteria;
    let inquiryDataList = this.state.inquiryDataList;
    this.disable();
    this.setState({
      criteria: criteria,
      inquiryDataList: inquiryDataList,
      isPhysicalInventoryEntryFormOpen: true,
      isPhysicalInventoryListFormOpen: false,
      isShowSaveButton: false,
      isShowExecuteButton: false,
      isShowSelectButton: false,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: true,
      isShowModuleSearchContainer: true,
      isResetView: true,
    });
    if (this.state.isViewMode) {
      let pageTitle = this.moduleCaption + " - VIEW";
      this.setState({
        pageTitle: pageTitle,
        disabled: true,
      });
    }
    if (this.state.moduleKeyCode != "NEW") {
      this.setState({ disabled: true });
    }
  };
  onModuleKeyCodeChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== "NEW" && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value;
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  onModuleKeyCodeWithCriteriaOnChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== "NEW" && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value.toUpperCase();
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  selectButtonClick = (e) => {
    this.editPhysicalInventoryAdjustment(this.state.moduleKeyCode);
  };
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.state.showAutoCompleteFabricList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleName = "";
      criteria.fabricStyleColorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
        isShowColorLookup: false,
        colorList: [],
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.errorCallBack
    );
  }
  readByFabricCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        let simpleItemBean = {
          code: fabricStyle.fabricStyleCode,
          description: fabricStyle.fabricStyleName,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  fabricEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
    });
    this.readandsetFabricStyleDetail(fabricStyleCode);
    this.setState({ fabricPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteList });
  };
  onFabricColourCodeChange = (e) => {
    this.state.showAutoCompleteFabricColorList = true;
    let fabricStyleColorCode = e.target.value;
    let showAutoCompleteFabricColorList =
      this.state.showAutoCompleteFabricColorList;
    if (isEmpty(fabricStyleColorCode)) {
      this.state.showAutoCompleteFabricColorList = false;
      let showAutoCompleteFabricColorList =
        this.state.showAutoCompleteFabricColorList;
      let criteria = this.state.criteria;
      criteria.fabricStyleColorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricColorList: showAutoCompleteFabricColorList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "fabricStyleColorCode" &&
      showAutoCompleteFabricColorList === true &&
      fabricStyleColorCode !== ""
    ) {
      this.readFabricColourBySearchString(e.target.value);
    }
  };
  readFabricColourBySearchString(searchString) {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    if (!isEmpty(fabricStyle)) {
      fabricStyle.fabricStyleSkus.map((sku) => {
        if (
          sku.fabricStyleCode == criteria.fabricStyleCode &&
          sku.colorCode == searchString
        )
          skuBean = sku;
      });
    }
    criteria.fabricStyleColorCode = searchString;
    let colorList = this.state.colorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricColourEnterKeyEventHandler = (e) => {
    let fabricStyleColorCode = e.target.value;
    this.fabricStyleColorSelected(fabricStyleColorCode);
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricColorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricColorList: showAutoCompleteList });
  };
  fabricStyleColorSelected = (colorCode) => {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    if (!isEmpty(fabricStyle)) {
      fabricStyle.fabricStyleSkus.map((sku) => {
        if (
          sku.fabricStyleCode == criteria.fabricStyleCode &&
          sku.colorCode == colorCode
        )
          skuBean = sku;
      });
    }
    criteria.fabricStyleColorCode = colorCode;
    this.setState({ criteria: criteria });
  };
  readandsetFabricStyleDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        criteria.fabricStyleName = fabricStyle.description;
        let colors = fabricStyle.colors;
        let finalColorList = [];
        colors.map((ent) => {
          let colorBean = new BaseBean();
          colorBean.code = ent.fabricStyleColorCode;
          colorBean.description = ent.fabricStyleColorName;
          finalColorList.push(colorBean);
        });
        this.setState({ colorLookupHandler: null });
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color"
          );
          this.setState({
            colorLookupHandler: colorLookupHandler,
            isShowColorLookup: true,
            criteria: criteria,
            colorList: finalColorList,
            fabricStyleData: fabricStyle,
            isShowProgressBarPopup: false,
            progressLoadingText: "",
          });
        }
      }
    }
  };
  readandsetFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    this.setState({ isFabricStyleDataLoding: true });
    FabricStyleService.readFabricStyle(
      input,
      this.readandsetFabricStyleDetailResponse,
      this.errorCallBack
    );
  };
  execute = (e) => {
    if (e.detail == 1) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Executing ...",
      });
      let criteria = this.state.criteria;
      let criteriaLine = new SKUBatchInventoryBinLocationSearchCriteria();
      criteriaLine.companyCode = this.companyCode;
      criteriaLine.fromDate = criteria.fromDate;
      criteriaLine.toDate = criteria.toDate;
      criteriaLine.fabricStyleCode = criteria.fabricStyleCode;
      criteriaLine.includeHoldingWarehouse = criteria.includeHoldingWarehouse;
      criteriaLine.fabricStyleColorCode = criteria.fabricStyleColorCode;
      this.loadPhysicalInventoryList(criteriaLine);
    }
  };
  loadPhysicalInventoryList = (criteria) => {
    if (
      SecurityAccessManager.PhysicalInventoryAdjustmentMaintainance_IsAccessible()
    ) {
      InventoryService.getSkuBatchPhysicalInventoriesAllBinLocation(
        criteria,
        this.loadPhysicalInventoryPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadPhysicalInventoryPageResponse = (response) => {
    let criteria = this.state.criteria;
    let missInv = [];
    let phyInv = [];
    this.showErrorMessage(response.data);
    if (response.data != null) {
      let resultList = new Array();
      if (!isEmptyArray(response.data.physicalInventoryAdjustment)) {
        resultList = response.data.physicalInventoryAdjustment;
      }
      if (!isEmpty(resultList)) {
        let physicalInventoryAdjustmentBean =
          new PhysicalInventoryAdjustmentBean();
        physicalInventoryAdjustmentBean.companyCode = resultList.companyCode;
        physicalInventoryAdjustmentBean.code = this.state.moduleKeyCode;
        physicalInventoryAdjustmentBean.fromDate = resultList.fromDate;
        physicalInventoryAdjustmentBean.toDate = resultList.toDate;
        physicalInventoryAdjustmentBean.remarks = resultList.remarks;
        physicalInventoryAdjustmentBean.notes = resultList.notes;
        physicalInventoryAdjustmentBean.fabricStyleCode =
          resultList.fabricStyleCode;
        physicalInventoryAdjustmentBean.fabricStyleColorCode =
          resultList.fabricStyleColorCode;
        physicalInventoryAdjustmentBean.includeHoldingWarehouse =
          resultList.includeHoldingWarehouse;
        physicalInventoryAdjustmentBean.binLocations = resultList.binLocations;
        let binlocation = [];
        let binLocations = [];
        binLocations = resultList.binLocations;
        for (let item of binLocations) {
          criteria.companyCode = item.companyCode;
          criteria.physicalInventoryAdjustmentNumber = this.state.moduleKeyCode;
          criteria.isActive = item.isActive;
          criteria.binLocation = item.binLocation;
          criteria.createdBy = item.createdBy;
          criteria.createdDate = item.createdDate;
          criteria.updatedBy = item.updatedBy;
          criteria.updatedDate = item.updatedDate;
          criteria.physicalInventoryQuantity = item.physicalInventoryQuantity;
          criteria.totalInventoryQuantity = item.totalInventoryQuantity;
          criteria.totalInventoryRolls = item.totalInventoryRolls;
          criteria.totalMissingInventoryRolls = item.totalMissingInventoryRolls;
          criteria.totalPhysicalInventoryRolls =
            item.totalPhysicalInventoryRolls;
          criteria.uomCode = item.uomCode;
          criteria.lineNumber = item.lineNumber;
          criteria.missingInventoryQuantity = item.missingInventoryQuantity;
          criteria.adjustUnAvailable = item.adjustUnAvailable;
          criteria.missingInventories = item.missingInventories;
          missInv = criteria.missingInventories;
          criteria.physicalInventories = item.physicalInventories;
          phyInv = criteria.physicalInventories;
        }
        binlocation.push(criteria);
      }
      this.setState({
        inquiryDataList: resultList,
        missInv: missInv,
        phyInv: phyInv,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  errorCallBack = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error: " + error);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let tempCriteria = new PhysicalInventoryAdjustmentBean();
    tempCriteria.companyCode = this.companyCode;
    tempCriteria.fabricStyleName = "";
    tempCriteria.fabricStyleColorCode = "";
    tempCriteria.binLocations = [];
    let inquiryDataList = [];
    this.setState({
      criteria: tempCriteria,
      isShowColorLookup: false,
      colorList: new Array(),
      moduleKeyCode: "NEW",
      selectedRollSkuList: [],
      inquiryDataList: inquiryDataList,
      isShowColorLookup: false,
      colorList: new Array(),
      isShowLookup: true,
      isDisabledFields: false,
      missInv: [],
      phyInv: [],
    });
    this.state.criteria = tempCriteria;
    this.state.moduleKeyCode = "NEW";
    this.hideAlertCallBack();
    this.addNewPhysicalInventoryAdjustment();
  };
  resetView = () => {
    let criteria = this.state.criteria;
    this.state.isReseted = true;
    if (!this.state.isViewMode && this.isLocked)
      this.unlockPhysicalInventoryAdjustment(criteria.code);

    criteria = new PhysicalInventoryAdjustmentBean();
    criteria.fabricStyleColorCode = "";
    criteria.fabricStyleName = "";
    criteria.binLocations = [];
    let inquiryDataList = [];
    this.state.isViewMode = false;
    this.code = "NEW";
    this.setState({
      criteria: new PhysicalInventoryAdjustmentBean(),
      isResetModule: true,
      moduleKeyCode: "NEW",
      selectedRollSkuList: [],
      inquiryDataList: inquiryDataList,
      isShowColorLookup: false,
      colorList: new Array(),
      isShowLookup: true,
      isDisabledFields: false,
      missInv: [],
      phyInv: [],
      disabled: false,
    });
    this.state.moduleKeyCode = "NEW";
    this.hideAlertCallBack();
    this.addNewPhysicalInventoryAdjustment();
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: new Array() });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewModule = (code) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowInventoryAdjustmentModule: true,
        moduleForPopup: (
          <PopupInventoryAdjustmentModule
            code={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  toPhysicalInventoryAdjustment = () => {};
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowInventoryAdjustmentModule: isOpen,
      moduleForPopup: [],
    });
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  getEmptyView() {
    return <div></div>;
  }
  getNodeList = () => {
    let nodeList = [];
    let emptyObject = this.getEmptyView();
    let nonVerifiedLineNode = new NodeData(
      "nonVerifiedLines",
      "Non Verified Lines",
      emptyObject,
      <ShieldAlert size={16}  />
    );
    let verifiedLineNode = new NodeData(
      "verifiedLine",
      "VerifiedLine",
      emptyObject,
      <ShieldCheck size={16} />
    );
    nodeList["nonVerifiedLines"] = nonVerifiedLineNode;
    nodeList["verifiedLine"] = verifiedLineNode;
    this.setState({ nodeList: nodeList });
  };
  nodeOnSelect = (selectedNode) => {
    this.setState({ selectedNodeKey: selectedNode });
    if (selectedNode == "nonVerifiedLines") {
      this.setNonVerifiedLines();
    } else if (selectedNode == "verifiedLine") {
      this.setverifiedLine();
    }
  };
  setNonVerifiedLines = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowNonVerified: true,
      isShowVerified: false,
    });
  };
  setverifiedLine = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowNonVerified: false,
      isShowVerified: true,
    });
  };
  closeAllNodeViews = () => {
    this.setState({
      isShowNonVerified: false,
      isShowVerified: false,
    });
  };
  selectAll = (e) => {
    let list = this.state.missInv;
    list.map((line) => {
      line.adjustUnAvailable = true;
    });
    this.setState({ selectedRollSkuList: list });
  };
  unSelectAll = (e) => {
    let list = this.state.missInv;
    list.map((line) => {
      line.adjustUnAvailable = false;
    });
    this.setState({ selectedRollSkuList: [] });
  };
  rollLineCheck = (val, rowData) => {
    if (this.state.isShowNonVerified == true) {
      if (rowData.adjustUnAvailable === true) {
        let selectedLine = this.state.selectedRollSkuList;
        selectedLine.push(rowData);
        this.setState({ selectedRollSkuList: selectedLine });
      } else {
        let checkLines = this.state.selectedRollSkuList;
        let selectedLine = [];
        for (let line of checkLines) {
          if (line.adjustUnAvailable != rowData.adjustUnAvailable) {
            selectedLine.push(line);
            this.setState({ selectedRollSkuList: selectedLine });
          } else if (this.state.selectedRollSkuList.length == 1) {
            this.setState({ selectedRollSkuList: [] });
          }
        }
      }
    } else {
      return null;
    }
  };
  columnDefinitions = () => {
    let columnList = [];
    if (this.state.isShowNonVerified == true) {
      this.state.checkTextBox = true;
    } else {
      this.state.checkTextBox = false;
    }
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails(
          "",
          "adjustUnAvailable",
          0,
          false, //set hyperlink false
          null, //set hyperLink call back null
          false,
          null
        )
        .setEditableDetails(
          false,
          "",
          null,
          false,
          null,
          this.state.checkTextBox,
          this.rollLineCheck
        )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Bin#", "binLocation")
    );
    if (this.state.is3PL) {
      columnList.push(
        new DataGridColumnDefinition().setDetails("Item", "fabricStyleCode")
      );
    } else {
      columnList.push(
        new DataGridColumnDefinition().setDetails(
          "FabricStyle",
          "fabricStyleCode"
        )
      );
    }
    columnList.push(
      new DataGridColumnDefinition().setDetails("Name", "fabricStyleName")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Color", "fabricStyleColorCode")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Sku#", "skuNumber", 1)
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        this.state.is3PL ? "Inventory#" : "RollSKU#",
        "rollSkuNumber",
        1
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Location", "locationCode")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "LotNumber",
        "vendorBatchNumber"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("RollNumber", "rollNumber")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("UOM", "uomCode")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "onHand Qty",
        "onHandQuantity",
        1
      )
    );

    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Verified Date",
        "lastPhysicalInventoryVerificationDate"
      )
    );
    return columnList;
  };

  save = (e) => {
    if (e.detail == 1) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Saving New Physical Inventory Adjustment ...",
      });
      let phyInv = [];
      let beanList = this.state.inquiryDataList;
      let selectedRollSkuList = this.state.selectedRollSkuList;
      let physicalInventoryAdjustmentBean =
        new PhysicalInventoryAdjustmentBean();
      if (!isEmpty(beanList)) {
        physicalInventoryAdjustmentBean.companyCode = beanList.companyCode;
        physicalInventoryAdjustmentBean.code = this.state.moduleKeyCode;
        physicalInventoryAdjustmentBean.fromDate = beanList.fromDate;
        physicalInventoryAdjustmentBean.toDate = beanList.toDate;
        physicalInventoryAdjustmentBean.remarks = beanList.remarks;
        physicalInventoryAdjustmentBean.notes = beanList.notes;
        physicalInventoryAdjustmentBean.fabricStyleCode =
          beanList.fabricStyleCode;
        physicalInventoryAdjustmentBean.fabricStyleColorCode =
          beanList.fabricStyleColorCode;
        physicalInventoryAdjustmentBean.includeHoldingWarehouse =
          beanList.includeHoldingWarehouse;
        let binlocation = [];
        let binLocations = beanList.binLocations;
        for (let item of binLocations) {
          let criteria = new PhysicalInventoryAdjustmentBinLocationBean();
          criteria.companyCode = item.companyCode;
          criteria.physicalInventoryAdjustmentNumber = this.state.moduleKeyCode;
          criteria.isActive = item.isActive;
          criteria.createdBy = item.createdBy;
          criteria.createdDate = item.createdDate;
          criteria.binLocation = item.binLocation;
          criteria.updatedBy = item.updatedBy;
          criteria.updatedDate = item.updatedDate;
          criteria.physicalInventoryQuantity = item.physicalInventoryQuantity;
          criteria.totalInventoryQuantity = item.totalInventoryQuantity;
          criteria.totalInventoryRolls = item.totalInventoryRolls;
          criteria.totalMissingInventoryRolls = item.totalMissingInventoryRolls;
          criteria.totalPhysicalInventoryRolls =
            item.totalPhysicalInventoryRolls;
          criteria.uomCode = item.uomCode;
          criteria.lineNumber = item.lineNumber;
          criteria.missingInventoryQuantity = item.missingInventoryQuantity;
          criteria.adjustUnAvailable = item.adjustUnAvailable;
          let missingInventories = [];
          let missInv = [];
          missingInventories = selectedRollSkuList;
          if (!isEmptyArray(missingInventories)) {
            for (let item of missingInventories) {
              let missingInventoryBean =
                new PhysicalInventoryAdjustmentMissingInventoryBean();
              missingInventoryBean.companyCode = item.companyCode;
              missingInventoryBean.binLocation = item.binLocation;
              missingInventoryBean.fabricStyleCode = item.fabricStyleCode;
              missingInventoryBean.fabricStyleColorCode =
                item.fabricStyleColorCode;
              missingInventoryBean.fabricStyleName = item.fabricStyleName;
              missingInventoryBean.onHandQuantity = item.onHandQuantity;
              missingInventoryBean.skuNumber = item.skuNumber;
              missingInventoryBean.rollSkuNumber = item.rollSkuNumber;
              missingInventoryBean.locationCode = item.locationCode;
              missingInventoryBean.rollNumber = item.rollNumber;
              missingInventoryBean.vendorBatchNumber = item.vendorBatchNumber;
              missingInventoryBean.uomCode = item.uomCode;
              missingInventoryBean.lastPhysicalInventoryVerificationDate =
                item.lastPhysicalInventoryVerificationDate;
              missingInventoryBean.adjustUnAvailable = item.adjustUnAvailable;
              missingInventoryBean.widthCode = item.widthCode;
              missInv.push(missingInventoryBean);
            }
          }
          criteria.missingInventories = missInv;
          let physicalInventories = [];
          let phyInv = [];
          physicalInventories = item.physicalInventories;
          if (!isEmptyArray(physicalInventories)) {
            for (let item of physicalInventories) {
              let PhysicalInventoryBean =
                new PhysicalInventoryAdjustmentPhysicalInventoryBean();
              PhysicalInventoryBean.companyCode = item.companyCode;
              PhysicalInventoryBean.binLocation = item.binLocation;
              PhysicalInventoryBean.fabricStyleCode = item.fabricStyleCode;
              PhysicalInventoryBean.fabricStyleColorCode =
                item.fabricStyleColorCode;
              PhysicalInventoryBean.fabricStyleName = item.fabricStyleName;
              PhysicalInventoryBean.skuNumber = item.skuNumber;
              PhysicalInventoryBean.rollSkuNumber = item.rollSkuNumber;
              PhysicalInventoryBean.locationCode = item.locationCode;
              PhysicalInventoryBean.rollNumber = item.rollNumber;
              PhysicalInventoryBean.vendorBatchNumber = item.vendorBatchNumber;
              PhysicalInventoryBean.uomCode = item.uomCode;
              PhysicalInventoryBean.lastPhysicalInventoryVerificationDate =
                item.lastPhysicalInventoryVerificationDate;
              PhysicalInventoryBean.onHandQuantity = item.onHandQuantity;
              PhysicalInventoryBean.widthCode = item.widthCode;
              phyInv.push(PhysicalInventoryBean);
            }
          }
          criteria.physicalInventories = phyInv;
          binlocation.push(criteria);
        }
        physicalInventoryAdjustmentBean.binLocations = binlocation;
      }
      if (
        SecurityAccessManager.PhysicalInventoryAdjustmentCreation_IsAccessible()
      ) {
        InventoryService.createPhysicalInventoryAdjustment(
          physicalInventoryAdjustmentBean,
          this.savePhysicalInventoryAdjustmentResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess("Save Access Denied");
      }
    }
  };
  savePhysicalInventoryAdjustmentResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null) {
      let dataList = new Array();
      if (!isEmptyArray(response.data.physicalInventoryAdjustment)) {
        this.showInfoMessage(response.data);
        dataList = response.data.physicalInventoryAdjustment;
        let pageTitle = this.moduleCaption + " - EDIT";
        this.setState({
          criteria: dataList,
          pageTitle: pageTitle,
        });

        if (this.state.moduleKeyCode != "NEW") {
          this.unlockPhysicalInventoryAdjustment(dataList.code, false);
        }
        this.editPhysicalInventoryAdjustment(dataList.code);
        this.setState({
          isShowSaveButton: false,
          isShowExecuteButton: false,
          isShowSelectButton: false,
          isShowNewTextBoxButton: true,
          isShowLookup: false,
          isShowColorLookup: false,
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.physicalInventoryAdjustmentData;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ physicalInventoryAdjustmentData: sorted });
    }
  };
  render() {
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <ModuleToolBar
          onModuleExit={() => this.moduleExit()}
          onNewEntry={() => this.addNewPhysicalInventoryAdjustment()}
          pageTitle={this.state.pageTitle}
          resetView={() => this.resetView()}
          isShowModuleSearchContainer={this.state.isShowModuleSearchContainer}
          isMaintenanceMode={!this.state.isPhysicalInventoryListFormOpen}
          moduleKeyCode={this.state.moduleKeyCode}
          onModuleKeyCodeChange={this.onModuleKeyCodeChange}
          onModuleKeyCodeWithCriteriaOnChange={
            this.onModuleKeyCodeWithCriteriaOnChange
          }
          selectButtonClick={this.selectButtonClick}
          onModuleKeyContainerButtonClick={this.editPhysicalInventoryAdjustment}
          lookupRequired={true} //for f2 lookup
          lookupHandler={this.state.physicalInventoryAdjustmentLookupHandler} //for f2 lookup
          getModuleListView={this.getModuleListView}
          showCriteriaDialog={true} //for f2 lookup
          isResetView={this.state.isResetView}
          isFocusLookup={this.state.isFocusLookup}
          disabled={this.state.disabled}
        />
        {this.state.isPhysicalInventoryEntryFormOpen &&
          this.state.isViewMode == false && (
            <BaseToolBar
              extend_toolbar={
                <>
                  {this.state.isShowExecuteButton && (
                    <Button
                      className="header_buttons btn-flx"
                      size="sm"
                      onClick={(e) => this.execute(e)}
                    >
                        <Download size={16} />
                      Fetch
                    </Button>
                  )}
                  {this.state.isShowSaveButton && (
                    <Button
                      className="header_buttons btn-flx"
                      size="sm"
                      onClick={(e) => this.save(e)}
                    >
                     <AlertCircle size={16}/>
                      Adjust Unavailable
                    </Button>
                  )}
                </>
              }
              pageTitle={this.state.pageTitle}
              isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
              isShowClearErrorButton={this.state.isShowClearErrorButton}
              clearCriteria={this.clearCriteria}
              clearError={this.clearError}
            />
          )}
        {this.state.isPhysicalInventoryListFormOpen && (
          <PhysicalInventoryAdjustmentListForm
            {...this.state}
            loadFirst={this.loadFirst}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
            loadLast={this.loadLast}
            editPhysicalInventoryAdjustment={
              this.editPhysicalInventoryAdjustment
            }
            filter={this.filter}
            resetFilteredCR={this.resetFilteredCR}
            resetFilter={this.resetFilter}
            listFormOnChange={this.listFormOnChange}
            handleSortingChange={this.handleSortingChange}
          />
        )}
        {this.state.isPhysicalInventoryEntryFormOpen && (
          <PhysicalInventoryAdjustmentEntryForm
            {...this.state}
            onChange={this.onChange}
            selectAll={this.selectAll}
            unSelectAll={this.unSelectAll}
            nodeOnSelect={this.nodeOnSelect}
            viewModule={this.viewModule}
            fabricCodeOnChange={this.fabricCodeOnChange}
            fabricCodeRef={this.fabricCodeRef}
            fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
            displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
            fabricColourEnterKeyEventHandler={
              this.fabricColourEnterKeyEventHandler
            }
            displayAutoCompleteFabricColorList={
              this.displayAutoCompleteFabricColorList
            }
            onFabricColourCodeChange={this.onFabricColourCodeChange}
            columnDefinitions={this.columnDefinitions}
          />
        )}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowInventoryAdjustmentModule}
          popupLvlClass={"popupSizeLevel0"}
          closeOnEsc={false}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
class PhysicalInventoryAdjustmentListForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: "",
      pageList: this.props.pageList,
    };
    this.searchRef = React.createRef();
  }
  componentDidMount() {
    if (this.searchRef.current != null) {
      this.searchRef.current.focus();
    }
  }
  listFormOnChange = (e) => {
    this.props.listFormOnChange(e);
  };
  filter = (e) => {
    if (e.detail == 1) this.props.filter();
  };
  resetFilter = (e) => {
    if (e.detail == 1) this.props.resetFilter();
  };
  loadFirst = (e) => {
    if (e.detail == 1) this.props.loadFirst();
  };
  loadNext = (e) => {
    if (e.detail == 1) this.props.loadNext();
  };
  loadPrevious = (e) => {
    if (e.detail == 1) this.props.loadPrevious();
  };
  loadLast = (e) => {
    if (e.detail == 1) this.props.loadLast();
  };
  editPhysicalInventoryAdjustment = (e, val, rowData) => {
    if (e.detail == 1) this.props.editPhysicalInventoryAdjustment(val);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail == 1) this.props.handleSortingChange(accessor);
  };
  onKeyDown = (e) => {
    if (e.keyCode == 13) {
      this.props.filter();
    }
  };

  render() {
    let physicalInventoryAdjustmentData =
      this.props.physicalInventoryAdjustmentData;
    let listCriteria = this.props.listCriteria;
    let pageList = this.props.pageList;
    let totalPages = 0;
    let pageSize = pageList.pageSize;
    let totalCount = pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    return (
      <div>
        <div className="secondary_module_header">
          <div className="secondary_module_header_title">
            <FormLabel className="secondary_module_search_color">
              Search
            </FormLabel>
            <span className="secondary_module_header_title_2">
              <InputTextbox
                ref={this.searchRef}
                name="physicalInventoryAdjustmentNumber"
                type="text"
                value={listCriteria.physicalInventoryAdjustmentNumber}
                placeholder="Enter Value to Filter.."
                onChange={this.listFormOnChange}
                onKeyDown={this.onKeyDown}
              />
            </span>

            <span className="px-2"></span>
            <Button size="sm" onClick={(e) => this.filter(e)}>
              Filter
            </Button>
            <span className="px-2"></span>
            <Button size="sm" onClick={(e) => this.resetFilter(e)}>
              Reset
            </Button>
          </div>
          <div className="module_header_secondary_buttons">
            <span>
              PAGE - {pageList.currentPage} OF {parseInt(totalPages)}
            </span>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadFirst(e)}
            >
              First
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadPrevious(e)}
            >
              Previous
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadNext(e)}
            >
              Next
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadLast(e)}
            >
              Last
            </Button>
          </div>
        </div>
        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Inv Physical Code
                  {this.state.order === "code" &&
                  this.state.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "createdDate")}>
                  Created Date
                  {this.state.order === "code" &&
                  this.state.sortField === "createdDate" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "fromDate")}>
                  Start Date
                  {this.state.order === "code" &&
                  this.state.sortField === "fromDate" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "toDate")}>
                  Stop Date
                  {this.state.order === "code" &&
                  this.state.sortField === "toDate" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "remarks")}>
                  Remarks
                  {this.state.order === "code" &&
                  this.state.sortField === "remarks" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </tr>
            </thead>
            {physicalInventoryAdjustmentData != null ? (
              <tbody>
                {physicalInventoryAdjustmentData.map((inv, index) => (
                  <tr key={index}>
                    <td className="hyperLinkText">
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.editPhysicalInventoryAdjustment(e, inv.code)
                        }
                      >
                        {inv.code}
                      </Button>
                    </td>
                    <td>{inv.createdDate}</td>
                    <td>{inv.fromDate}</td>
                    <td>{inv.toDate}</td>
                    <td>{inv.remarks}</td>
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {physicalInventoryAdjustmentData.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}
export function PhysicalInventoryAdjustmentEntryForm(props) {
  const onChange = (e) => props.onChange(e);
  const viewModule = (e) => {
    if (e.detail == 1) props.viewModule(e);
  };
  const selectAll = (e) => {
    if (e.detail <= 1) props.selectAll();
  };
  const unSelectAll = (e) => {
    if (e.detail <= 1) props.unSelectAll();
  };
  const fabricCodeOnChange = (e) => props.fabricCodeOnChange(e);
  const onFabricColourCodeChange = (e) => {
    props.onFabricColourCodeChange(e);
  };
  const fabricEnterKeyEventHandler = (e) => {
    props.fabricEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricList = () => {
    props.displayAutoCompleteFabricList();
  };

  const fabricColourEnterKeyEventHandler = (e) => {
    props.fabricColourEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricColorList = () => {
    props.displayAutoCompleteFabricColorList();
  };
  const textAreaStyle = {
    maxHeight: "9em",
    width: "40em",
    resize: "none",
    padding: "9px",
    boxSizing: "border-box",
    fontSize: "12px",
  };
  const columnDefinitions = (e) => props.columnDefinitions(e);
  const nodeOnSelect = (e) => props.nodeOnSelect(e);
  let criteria = props.criteria;
  let fabricCodeRef = React.createRef();
  let missInv = props.missInv;
  let phyInv = props.phyInv;
  let beanList = props.inquiryDataList;
  return (
    <div>
      <div>
        <Row className="d-flex justify-content-left">
          <Col sm="1">
            {props.is3PL ? (
              <FormLabel>Item</FormLabel>
            ) : (
              <FormLabel>FabricStyle</FormLabel>
            )}
          </Col>
          <Col sm="2">
            <InputTextbox
              ref={fabricCodeRef}
              name="fabricStyleCode"
              onChange={fabricCodeOnChange}
              value={criteria.fabricStyleCode}
              lookupRequired={props.isShowLookup}
              lookupHandler={props.fabricLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={fabricEnterKeyEventHandler}
              autoCompleteListData={props.fabricPageListForAutoCompleteList}
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={displayAutoCompleteFabricList}
              showAutoCompleteList={props.showAutoCompleteFabricList}
              disabled={props.isDisabledFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="3">
            <InputTextbox
              name="fabricStyleName"
              onChange={onChange}
              value={criteria.fabricStyleName}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Color</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={onFabricColourCodeChange}
              name="fabricStyleColorCode"
              placeholder="color"
              value={criteria.fabricStyleColorCode}
              lookupRequired={props.isShowColorLookup}
              lookupHandler={props.colorLookupHandler}
              enterKeyEventHandler={fabricColourEnterKeyEventHandler}
              autoCompleteListData={
                props.fabricColourPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={displayAutoCompleteFabricColorList}
              showAutoCompleteList={props.showAutoCompleteFabricColorList}
              disabled={!props.isShowColorLookup}
            />
          </Col>
          <Col md={1}>
            <InputCheckbox
              type="checkbox"
              name="isIncludeHoldingWareHouse"
              onChange={onChange}
              checked={criteria.isIncludeHoldingWareHouse}
              disabled={props.isDisabledFields}
            />
          </Col>
          <Col md={0.9}>
            <FormLabel>Holding WareHouse</FormLabel>
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>StartDate</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent
              name="fromDate"
              value={criteria.fromDate}
              onChange={onChange}
              disabled={props.isDisabledFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>StopDate</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent
              name="toDate"
              value={criteria.toDate}
              onChange={onChange}
              disabled={props.isDisabledFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Remarks</FormLabel>
          </Col>
          <Col sm="2">
            <textarea
              style={textAreaStyle}
              className="form-control"
              name="remarks"
              type="text"
              placeholder="Enter comments"
              value={criteria.remarks}
              onChange={onChange}
              disabled={props.isDisabledFields}
            />
          </Col>
        </Row>
        {props.isShowNewTextBoxButton && (
          <Row>
            <Col sm="1">
              <FormLabel
                className="hyperLinkText"
                onClick={(e) =>
                  viewModule(e, criteria.inventoryAdjustmentNumber)
                }
              >
                Inv Adjustment#
              </FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="inventoryAdjustmentNumber"
                type="text"
                value={criteria.inventoryAdjustmentNumber}
                disabled={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Created By</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="createdBy"
                type="text"
                value={criteria.createdBy}
                disabled={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Created Date</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="createdDate"
                type="text"
                value={criteria.createdDate}
                disabled={true}
              />
            </Col>
          </Row>
        )}
        <Row>
          <Col sm="2">
            <FormLabel className="label_head">Physical Inventory Lines</FormLabel>
          </Col>

          <Col sm="1">
            {props.isShowSelectButton && (
              <Button
                size="sm"
                variant="secondry"
                id="fabric_Add_Button"
                className="enterFocus"
                onClick={(e) => selectAll(e)}
              >
                SelectAll
              </Button>
            )}
          </Col>

          <Col sm="1">
            {props.isShowSelectButton && (
              <Button
                size="sm"
                variant="secondry"
                id="fabric_Add_Button"
                className="enterFocus"
                onClick={(e) => unSelectAll(e)}
              >
                UnselectAll
              </Button>
            )}
          </Col>
        </Row>
      </div>
      <div>
        <Row>
          <BaseNodeBar
            nodeList={props.nodeList}
            selectedNodeKey={props.selectedNodeKey}
            nodeOnSelect={nodeOnSelect}
          />
        </Row>
      </div>
      {props.isShowNonVerified && (
        <div className="div_Custom_4">
          <EditableDataGrid
            columnsList={columnDefinitions()}
            dataList={missInv}
          />
        </div>
      )}
      {props.isShowVerified && (
        <div className="div_Custom_4">
          <EditableDataGrid
            columnsList={columnDefinitions()}
            dataList={phyInv}
          />
        </div>
      )}
    </div>
  );
}
function PhysicalInventoryAdjustmentModule(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <PhysicalInventoryAdjustment {...props} name="" /> <br />
    </div>
  );
}
export default PhysicalInventoryAdjustmentModule;
